import { render, staticRenderFns } from "./FullImageContent.vue?vue&type=template&id=6db0857a&scoped=true&"
import script from "./FullImageContent.vue?vue&type=script&lang=js&"
export * from "./FullImageContent.vue?vue&type=script&lang=js&"
import style0 from "./FullImageContent.vue?vue&type=style&index=0&id=6db0857a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0857a",
  null
  
)

export default component.exports